<div class="container-page page-cotacoes" *ngIf="!isComponent">
    <button mat-button class="button-update-list" *ngIf="atualizarLista" (click)="atualizarListaCotacoes()">{{novasCotacoes}}</button>

    <div class="container-tab-group-cotacoes">
        <mat-tab-group class="tab-group-cotacoes" #tabGroup
        [selectedIndex]="ramoSelecionado.value" (selectedIndexChange)="ramoSelecionado.setValue($event);filtrarBtn(ramos[$event].id)">
            <mat-tab *ngFor="let ramo of ramos" [label]="ramo.titulo | uppercase"></mat-tab>
        </mat-tab-group>
        
        <div class="filtros-container">
            <form class="form-filtros-cotacoes">
                <mat-form-field class="col-12">
                    <mat-label>Período</mat-label>
                    <mat-select [formControl]="periodo" (selectionChange)="filtrar()">
                        <mat-option *ngFor="let element of periodoOptions" [value]="element.value">
                        {{element.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
        </div>

        <div class="select-ramos">
            <mat-form-field class="form-field-selecionar-ramos-cotacao">
                <mat-select [formControl]="ramoSelecionado" disableOptionCentering panelClass="panel-select-ramos-cotacao">
                  <mat-option class="panel-option" *ngFor="let item of ramos;  let i = index;" (click)="tabGroup.selectedIndex = i" [value]="i">
                    <mat-icon class="mat-tab-icon-label mr-2 icon-ramo" [svgIcon]="item.icone"></mat-icon>
                    <span class="mat-tab-custom-label">{{ item.titulo }}</span>
                  </mat-option>
                  <mat-select-trigger class="trigger">
                    <mat-icon class="ramo-icon" [svgIcon]="ramos[ramoSelecionado.value]?.icone"></mat-icon>
                    {{ramos[ramoSelecionado.value]?.titulo}}
                  </mat-select-trigger>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div *ngIf="!lista.length && !loading && !campoBusca && !filtrou" class="card-sem-resultados-encontrados">
        <mat-icon [svgIcon]="'database-eye-off'"></mat-icon>
        <span class="subtitle-small">
            Ainda não há dados para exibir.
        </span>
        <span class="subtitle-small">
            Por favor registre uma nova cotação.
        </span>
    </div>

    <div class="card-sem-resultados-encontrados" *ngIf="!lista.length && !loading && (campoBusca || filtrou)">
        <mat-icon [ngStyle]="{'padding':'0 4px 0 0'}" [svgIcon]="'file-search'"></mat-icon>
        <span class="subtitle-small">
            Desculpe, não localizamos nenhum registro para exibir.
        </span>
    </div>

    <div class="title-table" [hidden]="!lista.length && !loading">
        <div class="ramo table-header">
            <span></span>
        </div>
        <div class="info">
            <div class="segurado table-header">
                <span>Segurado</span>
            </div>
            <div class="item table-header">
                <span>Item</span>
            </div>
            <div class="usuario table-header">
                <span>Usuário</span>
            </div>
            <div class="vigencia table-header">
                <span>Vigência</span>
            </div>
            <div class="data-calculo table-header">
                <span>Data Cálculo</span>
            </div>
        </div>
        <div class="status table-header">
            <span>Status</span>
        </div>
    </div>
    <ng-template
        #name
        let-cotacao="item">
        
        <div class="itemCotacao__row" (click)="open(cotacao.getLink())">

            <div class="itemCotacao__iconStart">
                <mat-icon
                    [matTooltip]="cotacao.getRotulo()"
                    class="tipo-icone"
                    [svgIcon]="cotacao.getIcon()"
                    [ngStyle]="{order:0}"
                    matListIcon>
                </mat-icon>
            </div>

            <div
                class="itemCotacao__grid"
                *ngIf="platformService.virtualDeviceType == 'desktop'">
                
                <div
                    [ngStyle]="{'display':'flex', 'align-items':'center', 'overflow': 'hidden'}" class="segurado" [matTooltip]="cotacao?.seguradoNome || 'Dados do segurado não informado'">
                    <span
                        class="fontHelvetica16 textOverflow personalData text-capitalize">
                        {{ cotacao?.seguradoNome || 'Dados do segurado não informado' }}
                    </span>
                </div>

                <div *ngIf="platformService.virtualDeviceType == 'desktop'" 
                [ngStyle]="{'display':'flex', 'align-items':'center', 'overflow': 'hidden'}" class="items">
                    <span
                        class="fontDefault textOverflow"
                        *ngIf="cotacao.ramo == 31 && (cotacao.placa || cotacao.modelo)" [matTooltip]="((cotacao.placa ? cotacao.placa + ' - ' : '') + (cotacao.modelo)).toUpperCase()">
                        <span class="personalData placa" >{{ cotacao.placa ? cotacao.placa + ' - ' : '' }}</span>
                        {{ cotacao.modelo }}
                    </span>
                    <span
                        class="fontDefault textOverflow"
                        *ngIf="cotacao.ramo == 2"
                        [matTooltip]="(cotacao.getTipoResidTxt() ? cotacao.getTipoResidTxt() + ' - ' : '') + (cotacao.getImovelConsTxt() ? cotacao.getImovelConsTxt() + ' - ' : '') + (cotacao.imovelCidade ? cotacao.imovelCidade + ' / ' : '') + (cotacao.imovelUF ? cotacao.imovelUF : '')">
                        {{ cotacao.getTipoResidTxt() ? cotacao.getTipoResidTxt() + ' - ' : '' }}{{ cotacao.getImovelConsTxt() ? cotacao.getImovelConsTxt() + ' - ' : ''  }}{{ cotacao.imovelCidade ? cotacao.imovelCidade + ' / ' : ''}}{{ cotacao.imovelUF ? cotacao.imovelUF : ''}}
                    </span>

                    <!-- RAMO ALUGUEL -->
                    <span 
                        class="fontDefault textOverflow"
                        [matTooltip]="(cotacao.getTipoAluguelTxt() ? cotacao.getTipoAluguelTxt() + ' - ' : '') + (cotacao.imovelCidade ? cotacao.imovelCidade + ' / ' : '') + (cotacao.imovelUF ? cotacao.imovelUF : '')"
                        *ngIf="cotacao.ramo == 46"
                    >
                    {{ cotacao.getTipoAluguelTxt() ? cotacao.getTipoAluguelTxt() + ' - ' : '' }}{{ cotacao.imovelCidade ? cotacao.imovelCidade + ' / ' : ''}}{{ cotacao.imovelUF ? cotacao.imovelUF : ''}}
                    </span>
                    
                    <span
                        class="fontDefault textOverflow"
                        *ngIf="cotacao.ramo == 711"
                        [matTooltip]="(cotacao.getMarcaBikeTxt() ? cotacao.getMarcaBikeTxt() + ' - ' : '') + (cotacao.modelo ? cotacao.modelo + ' - ' : '') + (cotacao.getTipoBikeTxt() ? cotacao.getTipoBikeTxt() : '')">
                        {{ cotacao.getMarcaBikeTxt() ? cotacao.getMarcaBikeTxt() + ' - ' : '' }}{{ cotacao.modelo ? cotacao.modelo + ' - ' : ''  }}{{ cotacao.getTipoBikeTxt() ? cotacao.getTipoBikeTxt() : '' }}
                    </span>
                    <span
                        class="fontDefault textOverflow"
                        *ngIf="cotacao.ramo == 18"
                        [matTooltip]="'Empresarial'">
                        Empresarial
                    </span>
                    <span
                        class="fontDefault textOverflow personalData"
                        *ngIf="cotacao.ramo == 91 || cotacao.ramo == 93 || cotacao.ramo == 81 || cotacao.ramo == 69"
                        [matTooltip]="(cotacao.seguradoCpfCnpj | mask: masks.getCpfCnpj(cotacao.seguradoCpfCnpj)) + ' - ' + (cotacao.fone1 | mask: masks.getFoneMask(cotacao.fone1))">
                        {{ cotacao.seguradoCpfCnpj | mask: masks.getCpfCnpj(cotacao.seguradoCpfCnpj)}} - {{ cotacao.fone1 | mask: masks.getFoneMask(cotacao.fone1)}}
                    </span>
                </div>

                <div *ngIf="platformService.virtualDeviceType == 'desktop'" class="itemCotacao__grid-usuario user" 
                [ngStyle]="{'display':'flex', 'align-items':'center', 'overflow': 'hidden'}"
                [matTooltip]="cotacao.usuario">
                    <span class="fontDefault textOverflow">
                        {{ cotacao.usuario }} 
                    </span>
                </div>

                <div *ngIf="platformService.virtualDeviceType == 'desktop'" class="itemCotacao__grid-date data"
                [ngStyle]="{'display':'flex', 'align-items':'center', 'overflow': 'hidden'}"
                [matTooltip]="cotacao.getPeriodoVigencia(cotacao.ramo)">
                    <span class="fontDefault textOverflow">
                        {{ cotacao.getPeriodoVigencia(cotacao.ramo) }}
                    </span>
                </div>

                <div *ngIf="platformService.virtualDeviceType == 'desktop'" class="itemCotacao__grid-date data"
                [ngStyle]="{'display':'flex', 'align-items':'center', 'overflow': 'hidden'}"
                [matTooltip]="cotacao.getData()">
                    <span class="fontDefault textOverflow">
                        {{ cotacao.getData() }}
                    </span>
                </div>

            </div>

            <div
                class="itemCotacao__label"
                *ngIf="platformService.virtualDeviceType != 'desktop'">
                <span class="fontHelvetica16 personalData">
                    {{ cotacao?.seguradoNome || 'Dados do segurado não informado' }}
                </span>
                <span
                    class="fontSmall"
                    [ngStyle]="{'margin-top':'3px'}"
                    *ngIf="cotacao.ramo == 31 && (cotacao.placa || cotacao.modelo)">
                    <span class="personalData">{{ cotacao.placa ? cotacao.placa + ' - ' : '' }}</span>
                    {{ cotacao.modelo }}
                </span>
                <span
                    class="fontSmall personalData"
                    [ngStyle]="{'margin-top':'3px'}"
                    *ngIf="cotacao.ramo == 2">
                    {{ cotacao.getTipoResidTxt() ? cotacao.getTipoResidTxt() + ' - ' : '' }}{{ cotacao.getImovelConsTxt() ? cotacao.getImovelConsTxt() + ' - ' : ''  }}{{ cotacao.imovelCidade ? cotacao.imovelCidade + ' / ' : ''}}{{ cotacao.imovelUF ? cotacao.imovelUF : ''}}
                </span>

                <!-- RAMO ALUGUEL -->
                <span 
                    class="fontSmall personalData"
                    [matTooltip]="(cotacao.getTipoAluguelTxt() ? cotacao.getTipoAluguelTxt() + ' - ' : '') + (cotacao.imovelCidade ? cotacao.imovelCidade + ' / ' : '') + (cotacao.imovelUF ? cotacao.imovelUF : '')"
                    *ngIf="cotacao.ramo == 46"
                >
                {{ cotacao.getTipoAluguelTxt() ? cotacao.getTipoAluguelTxt() + ' - ' : '' }}{{ cotacao.imovelCidade ? cotacao.imovelCidade + ' / ' : ''}}{{ cotacao.imovelUF ? cotacao.imovelUF : ''}}
                </span>

            </div>

            <div
                *ngIf="cotacao"
                class="itemCotacao__iconEnd">
                <span
                    [ngStyle]="{'height':'24px', 'width':'24px', 'display':'flex'}"
                    [matTooltip]="cotacao.getRotuloStatus()">
                    <mat-icon
                        matPrefix
                        [svgIcon]="cotacao.getIconStatus()?.icon"
                        [ngClass]="['iconSvgCustom', cotacao.getIconStatus()?.icon == 'calculando' ? 'iconSvgCustom-calculando' : '', cotacao.status == 4 ? 'status-fechado' : cotacao.status == 5 ? 'status-perdido' : '']"
                        matListIcon>
                    </mat-icon>
                </span>
            </div>
        </div>

    </ng-template>

    <div class="container-loader" [ngStyle]="{ 'top': alturaApp ? ((alturaApp - 80) / 2) + 'px' : '50%' }"
        *ngIf="loading && this.listaScrolling.pullReloadingAnimation !== 'show'">
        <loading-page></loading-page>
    </div>

    <div class="table-skeleton" *ngIf="loading && this.listaScrolling.pullReloadingAnimation !== 'show'">
        <table class="w-100 noselect" matSort>
            <tr *ngFor="let row of arraySkeleton">
                <td *ngFor="let size of row">
                    <div class="sket" [ngStyle]="{ 'width': size.toString() + '%' }"> . </div>
                </td>
            </tr>
        </table>
    </div>

    <lista-scrolling
        #listaScrolling
        [template]="name"
        [listaItems]="lista"
        (updateLista)="updateLista($event)"
        [maxWidth]="true"
        [ngStyle]="{'visibility': loading && listaScrolling.pullReloadingAnimation !== 'show' ? 'hidden' : 'initial'}"
        ></lista-scrolling>

</div>

<div class="container-component" *ngIf="isComponent">
    <ng-template
        #name
        let-cotacao="item">
        <div class="itemCotacao__row" (click)="open(cotacao.getLink())">

            <div class="itemCotacao__iconStart">
                <mat-icon
                    [matTooltip]="cotacao.getRotulo()"
                    class="tipo-icone"
                    [svgIcon]="cotacao.getIcon()"
                    [ngStyle]="{order:0}"
                    matListIcon>
                </mat-icon>
            </div>

            <div
                class="itemCotacao__grid"
                *ngIf="platformService.virtualDeviceType == 'desktop'">
                <div
                    [ngStyle]="{'display':'flex', 'align-items':'center'}">
                    <span
                        class="fontHelvetica16 textOverflow personalData">
                        {{ cotacao?.seguradoNome || 'Dados do segurado não informado' }}
                    </span>
                </div>

                <div *ngIf="platformService.virtualDeviceType == 'desktop'">
                    <span
                        class="fontDefault textOverflow"
                        *ngIf="cotacao.ramo == 31 && (cotacao.placa || cotacao.modelo)">
                        <span class="personalData">{{ cotacao.placa ? cotacao.placa + ' - ' : '' }}</span>
                       {{ cotacao.modelo }}
                    </span>
                    <span
                        class="fontDefault textOverflow"
                        *ngIf="cotacao.ramo == 2">
                        {{ cotacao.getTipoResidTxt() ? cotacao.getTipoResidTxt() + ' - ' : '' }}{{ cotacao.getImovelConsTxt() ? cotacao.getImovelConsTxt() + ' - ' : ''  }}{{ cotacao.imovelCidade ? cotacao.imovelCidade + ' / ' : ''}}{{ cotacao.imovelUF ? cotacao.imovelUF : ''}}
                    </span>
                    <span
                        class="fontDefault textOverflow"
                        *ngIf="cotacao.ramo == 711">
                        {{ cotacao.getMarcaBikeTxt() ? cotacao.getMarcaBikeTxt() + ' - ' : '' }}{{ cotacao.modelo ? cotacao.modelo + ' - ' : ''  }}{{ cotacao.getTipoBikeTxt() ? cotacao.getTipoBikeTxt() : '' }}
                    </span>
                    
                    <!-- RAMO ALUGUEL -->
                    <span 
                        class="fontDefault textOverflow"
                        [matTooltip]="(cotacao.getTipoAluguelTxt() ? cotacao.getTipoAluguelTxt() + ' - ' : '') + (cotacao.imovelCidade ? cotacao.imovelCidade + ' / ' : '') + (cotacao.imovelUF ? cotacao.imovelUF : '')"
                        *ngIf="cotacao.ramo == 46"
                    >
                    {{ cotacao.getTipoAluguelTxt() ? cotacao.getTipoAluguelTxt() + ' - ' : '' }}{{ cotacao.imovelCidade ? cotacao.imovelCidade + ' / ' : ''}}{{ cotacao.imovelUF ? cotacao.imovelUF : ''}}
                    </span>

                    <span
                        class="fontDefault textOverflow"
                        *ngIf="cotacao.ramo == 18">
                        Empresarial  
                    </span>
                    <span
                        class="fontDefault textOverflow personalData"
                        *ngIf="cotacao.ramo == 91 || cotacao.ramo == 93 || cotacao.ramo == 81 || cotacao.ramo == 69">
                        {{ cotacao.seguradoCpfCnpj | mask: masks.getCpfCnpj(cotacao.seguradoCpfCnpj)}} - {{ cotacao.fone1 | mask: masks.getFoneMask(cotacao.fone1)}}
                    </span>
                </div>

                <div *ngIf="platformService.virtualDeviceType == 'desktop'" class="itemCotacao__grid-usuario">
                    <span class="fontDefault textOverflow">
                        {{ cotacao.usuario }} 
                    </span>
                </div>

                <div *ngIf="platformService.virtualDeviceType == 'desktop'" class="itemCotacao__grid-date"  
                [matTooltip]="cotacao.getPeriodoVigencia(cotacao.ramo)">
                    <span class="fontDefault textOverflow">
                        {{ cotacao.getPeriodoVigencia(cotacao.ramo) }}
                    </span>
                </div>

            </div>

            <div
                class="itemCotacao__label"
                *ngIf="platformService.virtualDeviceType != 'desktop'">
                <span class="fontHelvetica16 personalData">
                    {{ cotacao?.seguradoNome || 'Dados do segurado não informado' }}
                </span>
                <span
                    class="fontSmall"
                    [ngStyle]="{'margin-top':'3px'}"
                    *ngIf="cotacao.ramo == 31 && (cotacao.placa || cotacao.modelo)">
                    <span class="personalData">{{ cotacao.placa ? cotacao.placa + ' - ' : '' }}</span>
                    {{ cotacao.modelo }}
                </span>
                <span
                    class="fontSmall"
                    [ngStyle]="{'margin-top':'3px'}"
                    *ngIf="cotacao.ramo == 2">
                    {{ cotacao.getTipoResidTxt() ? cotacao.getTipoResidTxt() + ' - ' : '' }}{{ cotacao.getImovelConsTxt() ? cotacao.getImovelConsTxt() + ' - ' : ''  }}{{ cotacao.imovelCidade ? cotacao.imovelCidade + ' / ' : ''}}{{ cotacao.imovelUF ? cotacao.imovelUF : ''}}
                </span>
                <span
                    class="fontSmall"
                    [ngStyle]="{'margin-top':'3px'}"
                    *ngIf="cotacao.ramo == 711">
                    {{ cotacao.getMarcaBikeTxt() ? cotacao.getMarcaBikeTxt() + ' - ' : '' }}{{ cotacao.modelo ? cotacao.modelo + ' - ' : ''  }}{{ cotacao.getTipoBikeTxt() ? cotacao.getTipoBikeTxt() : '' }}
                </span>

                <!-- RAMO ALUGUEL -->
                <span
                    class="fontSmall"
                    [ngStyle]="{'margin-top':'3px'}"
                    *ngIf="cotacao.ramo == 46">
                    {{ cotacao.getTipoAluguelTxt() ? cotacao.getTipoAluguelTxt() + ' - ' : '' }}{{ cotacao.imovelCidade ? cotacao.imovelCidade + ' / ' : ''}}{{ cotacao.imovelUF ? cotacao.imovelUF : ''}}
                </span>

            </div>

            <div
                *ngIf="cotacao"
                class="itemCotacao__iconEnd">
                <span
                    [ngStyle]="{'height':'24px', 'width':'24px', 'display':'flex'}"
                    [matTooltip]="cotacao.getRotuloStatus()">
                    <mat-icon
                        matPrefix
                        [svgIcon]="cotacao.getIconStatus()?.icon"
                        [ngClass]="['iconSvgCustom', cotacao.getIconStatus()?.icon == 'calculando' ? 'iconSvgCustom-calculando' : '']"
                        matListIcon>
                    </mat-icon>
                </span>
            </div>
        </div>

    </ng-template>

    <lista-scrolling
        #listaScrolling
        [template]="name"
        [listaItems]="lista"
        (updateLista)="updateLista($event)"
        ></lista-scrolling>

</div>
